import React, { useEffect, useState } from 'react'
import './modal.css'
import ModalWrap from './index'
import { SelectType } from '../../store/models'
import Selector from '../Select/Select'
import { getRepublics, getOblasts, getRaions } from './../../Service/local'
import { observer } from 'mobx-react-lite'
import { places } from './../../store/place'
import { student } from './../../store/student'
import { GoTasklist } from 'react-icons/go'
import BlueBtn from '../SidBarButtons/BlueBtn'
import { useTranslation } from 'react-i18next'
import http from './../../Service/http'
import { toast } from 'react-toastify'

export interface DemandType {
	isOpen: boolean
	setIsOpen: () => void
	stud?: any
}

function DemandModal({ isOpen, setIsOpen }: DemandType) {
	const [reps, setReps] = useState<SelectType>({
		value: 0,
		label: 'Не выбрано'
	})
	const [obl, setObl] = useState<SelectType>({
		value: 0,
		label: 'Не выбрано'
	})
	const [raion, setRaion] = useState<SelectType>({
		value: 0,
		label: 'Не выбрано'
	})

	const getPlaces = async () => {
		const res = await getRepublics()
		places.newRepublic(res.data.Republics)
	}

	useEffect(() => {
		getPlaces()
	}, [student.student])
	async function getObl() {
		if (reps.value) {
			const obl = await getOblasts(reps.value)

			places.newOblast(obl.data.OblastList)
		}
	}
	const { t, i18n } = useTranslation()

	async function getRaion() {
		if (reps.value) {
			const raion = await getRaions(obl.value)
			places.newRaion(raion.data.RaionList)
		}
	}
	useEffect(() => {
		getObl()
	}, [reps])

	useEffect(() => {
		getRaion()
	}, [obl])

	const postInsertDocStudent = async () => {
		const res = await http.post('/insertDocStudent', {
			uid: student.student.id_student,
			fac: student.student.id_faculty,
			gid: student.student.id_group,
			doc: 2,
			year: student.student.id_a_year,
			district: raion.value
		})
		toast('Заявка отправлена на исполнение')
		if (res.data.result === 'Заявка отправлена на исполнение') {
			toast('Заявка отправлена на исполнение')
		}
		setIsOpen()
	}

	return (
		<>
			<ModalWrap isOpen={isOpen} setIsOpen={setIsOpen} id={12} title={'Справка   '}>
				{/* <div className="ellips"></div> */}

				<div className='main'>
					<div className='person'>
						<div className={'Ava_person'}>
							<img
								src={
									student.photo
										? student.photo
										: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRF0mkZsMkaywe4ecyexbpomRK2UmXnT-YAr9u_6Ezi11ZmhnFF7OKHYtN0rFsny-OpIZU&usqp=CAU'
								}
								alt='Avatar'
							/>
						</div>
						<div className='person_btns'>
							{student.student.id_student && (
								<a
									target={'_blank'}
									onClick={e => {
										if (raion.value == 0) e.preventDefault()
										postInsertDocStudent()
									}}
								>
									{/* href={`/bt/api/r/v-m?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&idr=${raion.value}&lang=${i18n.language}`} > */}
									<BlueBtn style={{ width: '100%', marginBottom: '12px' }} onclick={() => {}} title='Военкомат'>
										<GoTasklist></GoTasklist>
									</BlueBtn>
								</a>
							)}
						</div>
					</div>
					<div className='selectors'>
						<div className='webflow-style-input'>
							<label>{t('st:modal.titles.fio')}</label>
							<input readOnly={true} value={student.student.fio} className='' type='email' placeholder='ФИО'></input>
						</div>
						<div className='webflow-style-input'>
							<label>{t('st:modal.titles.course')}</label>
							<input readOnly={true} className='' value={student.student.p22} type='email' placeholder='Курс'></input>
						</div>
						<div className='webflow-style-input'>
							<label onClick={() => {}}>{t('st:modal.titles.group')}</label>
							<input readOnly={true} className='' value={student.student.p20} type='email' placeholder='Группа'></input>
						</div>
						<div className='webflow-style-input'>
							<label onClick={() => {}}>{t('st:modal.titles.reps')}</label>
							<Selector
								withBorder={false}
								options={places.republic}
								value={reps}
								placeholder={t('st:modal.titles.none')}
								onChange={(e: SelectType) => {
									setReps(e)
									setObl({
										value: 0,
										label: 'Не выбрано'
									})
									setRaion({
										value: 0,
										label: 'Не выбрано'
									})
								}}
								name='asd'
								title=''
								isSearchable={false}
								isDisabled={false}
								isClearable={false}
							/>
						</div>
						<div className='webflow-style-input'>
							<label onClick={() => {}}>{t('st:modal.titles.regs')}</label>
							<Selector
								withBorder={false}
								options={places.oblast}
								value={obl}
								placeholder={'Выберите'}
								onChange={(e: SelectType) => {
									setObl(e)
									setRaion({
										value: 0,
										label: 'Не выбрано'
									})
								}}
								name=''
								title=''
								isSearchable={false}
								isDisabled={false}
								isClearable={false}
							/>
						</div>
						<div className='webflow-style-input'>
							<label onClick={() => {}}>{t('st:modal.titles.area')}</label>
							<Selector
								withBorder={false}
								options={places.raion}
								value={raion}
								placeholder={'Выберите'}
								onChange={(e: SelectType) => {
									setRaion(e)
								}}
								name='asd'
								title=''
								isSearchable={false}
								isDisabled={false}
								isClearable={false}
							/>
						</div>
						{raion.value == 0 ? <p style={{ color: 'red', fontWeight: '700' }}>Район не выбран</p> : ''}
					</div>
				</div>
			</ModalWrap>
		</>
	)
}

export default observer(DemandModal)
